module.exports = __webpack_public_path__ + "static/media/elder_titan.439c7ee5.png";